import { Box, styled } from '@mui/material';

import { SMALL_PHONE_MEDIA_QUERY } from '@ui/checkout-components';

import type { UiCardProps } from './Card.types';

export const UiCard = ({ children, disablePadding, ...rest }: UiCardProps) => (
  <CardContainer disablePadding={disablePadding} {...rest}>
    {children}
  </CardContainer>
);

const CardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disablePadding',
})<{ disablePadding?: boolean }>(({ theme, disablePadding }) => ({
  display: 'flex',
  padding: disablePadding ? 0 : theme.spacing(5),
  borderRadius: theme.borders.borderRadius2,
  border: theme.borders.borderWidth1,
  borderColor: theme.tokens.summaryBorder,
  overflow: 'hidden',

  [`${SMALL_PHONE_MEDIA_QUERY}`]: {
    padding: disablePadding ? 0 : theme.spacing(4),
  },
}));
